import Map from "./map";
import Marker from "./marker";

Map.Marker = Marker;

export default Map;
